import * as types from '../../constants/ActionTypes'
import * as receiptActions from '../../actions/receiptActions'
import * as barcodeActions from '../../actions/barcodeActions'
import * as receiptFunctions from '../../functions/ReceiptFunctions'
import * as general from '../../constants/General'

function setSplitReceiptModalUnsafe(show, receiptlinesleft, receiptlinesright, confirm, dispatch, confirmbuttontext) {
    return {
        type: types.SET_SPLIT_RECEIPT_MODAL,
        show,
        receiptlinesleft,
        receiptlinesright,
        confirm,
        dispatch,
        confirmbuttontext
    }
}

export function setSplitReceiptModal(show, receiptlinesleft, receiptlinesright, confirm, confirmbuttontext) {
    return (dispatch) => {
        dispatch(setSplitReceiptModalUnsafe(show, receiptlinesleft, receiptlinesright, confirm, dispatch, confirmbuttontext));
    }
}

function splitReceiptModalAddLineUnsafe(receiptlinesleft, receiptlinesright) {
    return {
        type: types.SPLIT_RECEIPT_MODAL_RECEIPTLINE_SWITCH,
        receiptlinesleft,
        receiptlinesright
    }
}

export function splitReceiptModalAddLineLeft(lineid) {
    return (dispatch, getState) => {
        const receiptlinesleft = Object.assign([], getState().modalState.splitReceiptModal.receiptlinesleft);
        const receiptlinesright = Object.assign([], getState().modalState.splitReceiptModal.receiptlinesright);

        let lineSearch = {
            found: false,
            index: null
        }

        receiptlinesleft.map((line, index) => {
            if (line.id === lineid) {
                lineSearch.found = true;
                lineSearch.index = index;
            }
            return '';
        });

        receiptlinesright.map((line, index) => {
            if (line.id === lineid) {
                if (lineSearch.found) {
                    let lineupdate = Object.assign({}, receiptlinesleft[lineSearch.index]);
                    const singleprice = line.price / line.quantity;
                    lineupdate.quantity += line.quantity;
                    lineupdate.price = lineupdate.quantity * singleprice;
                    receiptlinesleft[lineSearch.index] = lineupdate;
                } else {
                    receiptlinesleft.push(line);
                }
                receiptlinesright.splice(index, 1);
                dispatch(splitReceiptModalAddLineUnsafe(receiptlinesleft, receiptlinesright));
            }
            return '';
        });

    }
}

export function splitReceiptModalAddLineRight(lineid, addAll = false) {
    return (dispatch, getState) => {
        let receiptlinesleft = Object.assign([], getState().modalState.splitReceiptModal.receiptlinesleft);
        let receiptlinesright = Object.assign([], getState().modalState.splitReceiptModal.receiptlinesright);

        const receiptlinesleftnew = [];
        const receiptlinesrightnew = [];

        if (!addAll) {

            let originalleft = null;
            let updatedleft = null;
            let updatedright = null;
            receiptlinesleft.map(line => {
                if (line.id === lineid) {
                    originalleft = line;
                    updatedleft = downQuantity(line);
                    if (updatedleft.quantity > 0) {
                        receiptlinesleftnew.push(updatedleft);
                    }
                } else {
                    receiptlinesleftnew.push(line);
                }
                return '';
            });

            let lineFound = false;
            receiptlinesright.map(line => {
                if (line.itemid === updatedleft.itemid
                    && receiptFunctions.compareConfiguration(updatedleft.configuration, line.configuration)
                    && line.linetype === updatedleft.linetype) {
                    updatedright = upQuantity(line);
                    receiptlinesrightnew.push(updatedright);
                    lineFound = true;
                } else {
                    receiptlinesrightnew.push(line);
                }
                return '';
            });

            if (!lineFound) {
                let newLine = Object.assign({}, originalleft);
                const singleprice = newLine.price / newLine.quantity;
                newLine.quantity = newLine.quantity < 0 ? -1 : 1;
                newLine.price = singleprice;
                receiptlinesrightnew.push(newLine);
            }

            dispatch(splitReceiptModalAddLineUnsafe(receiptlinesleftnew, receiptlinesrightnew));
        } else if (addAll) {
            const currentreceiptline = getReceiptLine(receiptlinesleft, parseInt(lineid, 10));
            const rightreceiptline = getReceiptLine(receiptlinesright, parseInt(lineid, 10));
            if (rightreceiptline.line !== undefined) {
                const updatedright = Object.assign({}, rightreceiptline.line);
                const currleft = Object.assign({}, currentreceiptline.line);
                const singleprice = updatedright.price / updatedright.quantity;
                updatedright.quantity += currleft.quantity;
                updatedright.price = updatedright.quantity * singleprice;
                receiptlinesright = updateReceiptLine(receiptlinesright, updatedright);
                receiptlinesleft.splice(currentreceiptline.index, 1);
            } else {
                receiptlinesleft.splice(currentreceiptline.index, 1);
                receiptlinesright.push(currentreceiptline.line);
            }
            dispatch(splitReceiptModalAddLineUnsafe(receiptlinesleft, receiptlinesright));
        }
    }
}

function getReceiptLine(receiptlines, lineid) {
    let result = {
        line: undefined,
        index: 0
    }
    receiptlines.map((line, index) => {
        if (line.id === lineid) {
            result.line = Object.assign({}, line);
            result.index = index;
        }
        return '';
    });
    return result;
}

function updateReceiptLine(receiptlines, receiptline) {
    receiptlines.map((line, index) => {
        if (line.id === receiptline.id) {
            receiptlines[index] = Object.assign({}, receiptline);
        }
        return '';
    })
    return receiptlines;
}

function upQuantity(receiptline) {
    let resultline = Object.assign({}, receiptline);
    const singleprice = resultline.price / resultline.quantity;
    resultline.quantity < 0 ? resultline.quantity -= 1 : resultline.quantity += 1;
    resultline.price = resultline.quantity * singleprice;
    return resultline;
}

function downQuantity(receiptline) {
    let resultline = Object.assign({}, receiptline)
    const singleprice = resultline.price / resultline.quantity;
    resultline.quantity < 0 ? resultline.quantity += 1 : resultline.quantity -= 1;
    resultline.price = resultline.quantity * singleprice;
    return resultline;
}

function setSearchModalUnsafe(show, searchlist, keyword) {
    return {
        type: types.SET_SEARCH_MODAL,
        show,
        searchlist,
        keyword
    }
}

export function setSearchModal(show, searchlist, keyword) {
    return dispatch => {
        dispatch(setSearchModalUnsafe(show, searchlist, keyword));
    }
}

function setReceiptModalUnsafe(show) {
    return {
        type: types.SET_RECEIPT_MODAL,
        show
    }
}
export function setReceiptModal(show) {
    return (dispatch, getState) => {
        dispatch(receiptActions.updateReceiptLines(receiptFunctions.setSelectedLine(getState, -1)));
        dispatch(setReceiptModalUnsafe(show));
    }
}

export function setPaymentModal(show) {
    return {
        type: types.SET_PAYMENT_MODAL,
        show
    }
}

export function setOrderConfirmationModal(show, objectitemnumber, receiptlines) {
    return {
        type: types.SET_ORDER_CONFIRMATION_MODAL,
        show,
        objectitemnumber,
        receiptlines
    }
}

export function setPaymentModalCardInserted(cardinserted) {
    return {
        type: types.SET_PAYMENT_MODAL_CARD_INSERTED,
        cardinserted
    }
}

export function setDatePickerModal(show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_DATEPICKER_MODAL,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setWeightModal(show, articleId, deviceId) {
    return {
        type: types.SET_WEIGH_MODAL,
        show,
        articleId,
        deviceId
    }
}

export function setCustomerExistsModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_CUSTOMEREXISTS_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setCustomerBaseModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_CUSTOMERBASE_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setCreateCustomerModal(show, callback, callbackparams, dispatch, labels, customerId) {
    return {
        type: types.SET_CREATE_CUSTOMER_MODAL,
        show,
        callback,
        callbackparams,
        dispatch,
        labels,
        customerId
    }
}

export function setCreateTicketModal(show, callback, callbackparams, dispatch, ticket, ticketusages) {
    return {
        type: types.SET_CREATE_TICKET_MODAL,
        show,
        callback,
        callbackparams,
        dispatch,
        ticket,
        ticketusages
    }
}

export function setTicketBaseModal(show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_TICKETBASE_MODAL,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setArticleBaseModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_ARTICLEBASE_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setConfigurationListModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_CONFIGURATIONLIST_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setWeightModalWeight(weight) {
    return {
        type: types.SET_WEIGH_MODAL_WEIGHT,
        weight
    }
}
export function setScaleStatus(message) {
    return {
        type: types.SET_SCALE_STATUS,
        message
    }
}

export function abortWeigh(deviceId) {
    return (dispatch, getState) => {
        const weighArticleParams = {
            PosDeviceGuid: getState().generalState.uniqueid,
            DeviceId: deviceId
        }

        fetch(general.API_URL_ABORTWEIGH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(weighArticleParams)
        }).then(response => response.json());
    }
}

export function processPayedInWebshopOrder(orderNumber){
    return (dispatch, getState) => {
        const receipt = {
            PosId: getState().generalState.posId,
            SystemUserId: getState().loginState.loggedin.id,
            Receipt: [],
            ReceiptNumber: 0,
            DeviceGuid: getState().generalState.uniqueid,
            OrderNumber: orderNumber,
            Devices: getState().generalState.devices
          };

        fetch(general.API_URL_PROCESS_PAYEDONWEBSHOP_PURCHASEORDER, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(receipt)
        })
        .then(response => console.log("response", response));
    }
}

export function setManagerLoginModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_MANAGERLOGIN_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setOrderListModal(listvalues, show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_ORDERLIST_MODAL,
        listvalues,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setSelectPagerModal(show, callback, callbackparams, dispatch) {
    return {
        type: types.SET_SELECT_PAGER_MODAL,
        show,
        callback,
        callbackparams,
        dispatch
    }
}

export function setChangeModal(show, amount) {
    return {
        type: types.SET_CHANGE_MODAL,
        show,
        amount
    }
}

export function setInputModal(show, message, placeholder, callback, callbackparams, dispatch) {
    return {
        type: types.SET_INPUT_MODAL,
        show,
        message,
        placeholder,
        callback,
        callbackparams,
        dispatch
    }
}

export function setInvoiceModal(show, invoiceType, receipts) {
    return {
        type: types.SET_INVOICE_MODAL,
        show,
        invoiceType,
        receipts
    }
}

export function setInvoiceInfoModal(show, isCredit, callback, callbackparams, dispatch) {
    return {
        type: types.SET_INVOICE_INFO_MODAL,
        show,
        isCredit,
        callback,
        callbackparams,
        dispatch
    }
}

const setReservationModalUnsafe = (show, reservation, paymentParam) => ({
    type: types.SET_RESERVATION_MODAL,
    show,
    reservation,
    paymentParam
})

export function setReservationModal(show, reservation, paymentParam) {
    return dispatch => {
        if (show) {
            dispatch(barcodeActions.setScannerInReservationMode());
        }
        else {
            dispatch(barcodeActions.clearScannerMode());
        }
        dispatch(setReservationModalUnsafe(show, reservation, paymentParam));
    }
}

export function showAddBalanceToTicketModalUnsafe(paymentId, amount) {
    return {
        type: types.SET_ADD_BALANCE_TO_TICKET_MODAL,
        data: {
            show: true,
            paymentId,
            amount
        }
    }
}

export function showAddBalanceToTicketModal(paymentId, amount) {
    return dispatch => {
        dispatch(barcodeActions.setScannerInCustomerMode());
        dispatch(showAddBalanceToTicketModalUnsafe(paymentId, amount));
    }
}

export function hideAddBalanceToTicketModalUnsafe() {
    return {
        type: types.SET_ADD_BALANCE_TO_TICKET_MODAL,
        data: {
            show: false
        }
    }
}

export function hideAddBalanceToTicketModal() {
    return dispatch => {
        dispatch(barcodeActions.clearScannerMode());
        dispatch(hideAddBalanceToTicketModalUnsafe());
    }
}

export function setCashRegistrationModal(show, isCashIn, description, amount) {
    return {
        type: types.SET_CASH_REGISTRATION_MODAL,
        show,
        isCashIn,
        description,
        amount
    }
}



// WEBPACK FOOTER //
// src/modal/actions/modalActions.js